/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Streaming settings for Drop update (excludes featuredStreams — managed via dedicated streaming endpoints)
 * @export
 * @interface UpdateDropStreamingSettings
 */
export interface UpdateDropStreamingSettings {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDropStreamingSettings
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDropStreamingSettings
     */
    allowParticipantStreams?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDropStreamingSettings
     */
    discoverableInLiveHub?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDropStreamingSettings
     */
    requireApproval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDropStreamingSettings
     */
    showViewerCounts?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateDropStreamingSettings
     */
    maxFeaturedStreams?: number;
}

/**
 * Check if a given object implements the UpdateDropStreamingSettings interface.
 */
export function instanceOfUpdateDropStreamingSettings(value: object): value is UpdateDropStreamingSettings {
    return true;
}

export function UpdateDropStreamingSettingsFromJSON(json: any): UpdateDropStreamingSettings {
    return UpdateDropStreamingSettingsFromJSONTyped(json, false);
}

export function UpdateDropStreamingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDropStreamingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'allowParticipantStreams': json['allowParticipantStreams'] == null ? undefined : json['allowParticipantStreams'],
        'discoverableInLiveHub': json['discoverableInLiveHub'] == null ? undefined : json['discoverableInLiveHub'],
        'requireApproval': json['requireApproval'] == null ? undefined : json['requireApproval'],
        'showViewerCounts': json['showViewerCounts'] == null ? undefined : json['showViewerCounts'],
        'maxFeaturedStreams': json['maxFeaturedStreams'] == null ? undefined : json['maxFeaturedStreams'],
    };
}

export function UpdateDropStreamingSettingsToJSON(json: any): UpdateDropStreamingSettings {
    return UpdateDropStreamingSettingsToJSONTyped(json, false);
}

export function UpdateDropStreamingSettingsToJSONTyped(value?: UpdateDropStreamingSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'allowParticipantStreams': value['allowParticipantStreams'],
        'discoverableInLiveHub': value['discoverableInLiveHub'],
        'requireApproval': value['requireApproval'],
        'showViewerCounts': value['showViewerCounts'],
        'maxFeaturedStreams': value['maxFeaturedStreams'],
    };
}

